var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"redirect-if-no-permission",rawName:"v-redirect-if-no-permission:LOCATIONS",arg:"LOCATIONS"}]},[_c('DataTable',{attrs:{"url":_vm.api.ACTIONS.LANDMARKS,"fieldsHiddenMain":[
      'deleted_at',
      'radius',
      'type',
      'landmark_type',
      'street_name',
      'street_number',
      'city',
      'clusters',
      'ejection_radius',
      'level',
      'parent_id',
      'ejection_polygon',
      'place_id',
      'formatted_address',
      'is_favorite',
      'is_passenger_favorite'
    ],"titles":_vm.titles,"actionsExtraMain":_vm.actionsExtraMain,"formatter":_vm.formatter,"initialUrlSearchParams":_vm.addType,"perPage":"100","title":_vm.$t('maps.stationList.stations')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }